import { Page } from "../../../../helbest";
import styles from "./Address.module.css";
import useAddress from "./useAddress";
import { ReactComponent as EmptyAddressIcon } from "../../../../assets/svg/empty-address.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/svg/plus.svg";
import AddEditAddress from "./AddEditAddress/AddEditAddress";
import Item from "./Item/Item";
import { useTranslation } from "react-i18next";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import Loading from "../../../components/Loading/Loading";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const Addresses = () => {
  const { t } = useTranslation();
  const {
    addresses,
    loading,
    onSelectLocation,
    onEditModalOpen,
    onDelete,
    onCreateModal,
    onSubmit,
  } = useAddress();

  return (
    <Page
      className="page-address"
      showFooter={false}
      headerFix
      customHeader={<HeaderBack title={t("profile.my.address")} />}
      customPageClassName={styles.pageWrapper}
    >
      {loading && (
        <div className="text-center mt-2">
          <Loading />
        </div>
      )}
      {addresses.length === 0 && !loading ? (
        <div className={styles.emptyAddress}>
          <EmptyAddressIcon />
          <p>{t("address.No_address")}</p>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            style={{
              fontWeight: "bold",
            }}
            onClick={onCreateModal}
          >
            {t("cart.address_add")}
          </Button>
        </div>
      ) : null}
      {addresses.length > 0 && (
        <div className={styles.addressesBox}>
          {addresses.map((address) => (
            <Item
              {...address}
              key={address.id}
              noCheckbox
              onEdit={onEditModalOpen}
              onDelete={onDelete}
            />
          ))}
          <div className={styles.addAddressButton} onClick={onCreateModal}>
            <div className={styles.addAddressButtonIconContainer}>
              <PlusIcon />
            </div>
            <span>{t("address.new_address")}</span>
          </div>
        </div>
      )}
      <AddEditAddress onSelectLocation={onSelectLocation} onSubmit={onSubmit} />
    </Page>
  );
};

export default Addresses;
